import { takeEvery } from 'redux-saga/effects';
import { GRAPH_REQUEST } from './actions';
import { onProductGraphRequest } from './effects';

export function* productGraphRequestSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(GRAPH_REQUEST, onProductGraphRequest);
}
